(function () {
  const MQ = window.matchMedia("(max-width: 1300px)");

  function setClosed(nav) {
    nav.classList.remove("is-open");
    const btn = nav.querySelector(".nav-toggle");
    const inner = nav.querySelector(".nav-items-inner");
    if (btn) btn.setAttribute("aria-expanded", "false");
    if (inner) inner.style.maxHeight = "0px";
  }

  function setOpen(nav) {
    nav.classList.add("is-open");
    const btn = nav.querySelector(".nav-toggle");
    const inner = nav.querySelector(".nav-items-inner");
    if (btn) btn.setAttribute("aria-expanded", "true");
    if (inner) inner.style.maxHeight = inner.scrollHeight + "px";
  }

  function sync(nav) {
    const inner = nav.querySelector(".nav-items-inner");
    const btn = nav.querySelector(".nav-toggle");
    if (!inner || !btn) return;

    if (!MQ.matches) {
      // Desktop: behave like before (no collapsing)
      nav.classList.remove("is-open");
      btn.setAttribute("aria-expanded", "false");
      inner.style.maxHeight = ""; // allow natural height
      return;
    }

    // Mobile: ensure a known start state (closed unless already open)
    if (nav.classList.contains("is-open")) {
      inner.style.maxHeight = inner.scrollHeight + "px";
      btn.setAttribute("aria-expanded", "true");
    } else {
      inner.style.maxHeight = "0px";
      btn.setAttribute("aria-expanded", "false");
    }
  }

  function syncAll() {
    document.querySelectorAll("[data-nav-dropdown]").forEach(sync);
  }

  // Delegated click: works for multiple instances + section re-renders
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".nav-toggle");
    if (!btn) return;

    const nav = btn.closest("[data-nav-dropdown]");
    if (!nav) return;

    // Only actually open/close on <=1200
    if (!MQ.matches) return;

    e.preventDefault();

    if (nav.classList.contains("is-open")) setClosed(nav);
    else setOpen(nav);
  });

  // Keep heights correct when viewport changes (and after theme editor updates)
  if (MQ.addEventListener) MQ.addEventListener("change", syncAll);
  else MQ.addListener(syncAll);

  document.addEventListener("DOMContentLoaded", syncAll);
  document.addEventListener("shopify:section:load", syncAll);
  document.addEventListener("shopify:section:reorder", syncAll);
  document.addEventListener("shopify:section:select", syncAll);
})();